
let _uc = {

    //加载基础代码
    load: function(){
        let js = '(function(w, d, t, s, q, m, n) {\n' +
            '        if (w.utq) return;\n' +
            '        q = w.utq = function() {\n' +
            '            q.process ? q.process(arguments) : q.queue.push(arguments);\n' +
            '        };\n' +
            '        q.queue = [];\n' +
            '        m = d.getElementsByTagName(t)[0];\n' +
            '        n = d.createElement(t);\n' +
            '        n.src = s;\n' +
            '        n.async = true;\n' +
            '        m.parentNode.insertBefore(n, m);\n' +
            '    })(window, document, \'script\', \'https://image.uc.cn/s/uae/g/0s/ad/utracking.js\');\n' +
            'utq(\'set\', \'convertMode\', true);\n' +
            'utq(\'set\', \'trackurl\', \'huichuan.sm.cn/lp\');';

        let _head = document.getElementsByTagName("head")[0];
        let script = document.createElement("script");
        script.append(js);
        _head.appendChild(script);
    },

    //加载事件代码 - 转化ID
    submit: function (convert_id) {
        try {
            utq('track', 'ViewContent', convert_id + '');

        } catch (e) {
            console.log(e)
        }
    },
};

export default _uc
